import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BacklogService {
    private backlogItemsSubject = new BehaviorSubject<any[]>([]);
    public backlogItems$ = this.backlogItemsSubject.asObservable();

    private generatedBacklogSubject = new BehaviorSubject<any[]>([]);
    public generatedBacklog$ = this.generatedBacklogSubject.asObservable();

    private workIdSubject = new BehaviorSubject<string>('');
    public workId$ = this.workIdSubject.asObservable();

    constructor() {}

    /**
     * Set the backlog items
     */
    public setBacklogItems(items: any[]): void {
        this.backlogItemsSubject.next(items);
    }

    /**
     * Get the current backlog items
     */
    public getBacklogItems(): any[] {
        return this.backlogItemsSubject.value;
    }

    /**
     * Clear backlog items
     */
    public clearBacklogItems(): void {
        this.backlogItemsSubject.next([]);
    }

    /**
     * Set the generated backlog items
     */
    public setGeneratedBacklog(items: any[]): void {
        this.generatedBacklogSubject.next(items);
    }

    /**
     * Get the current generated backlog items
     */
    public getGeneratedBacklog(): any[] {
        return this.generatedBacklogSubject.value;
    }

    /**
     * Clear generated backlog items
     */
    public clearGeneratedBacklog(): void {
        this.generatedBacklogSubject.next([]);
    }

    /**
     * Set the current workid
     */
    public setWorkId(workId: string): void {
        this.workIdSubject.next(workId);
        console.log('[BacklogService] setWorkId:', workId);
    }

    /**
     * Get the current workid
     */
    public getWorkId(): string {
        return this.workIdSubject.value;
    }
}
